import "./ChangePassword.css";
import PopUp from "../../components/PopUp";
import { ChangePassword } from "./ChangePasswordForm";

export default function Modal(props) {
  return (
    <div className="change-password-container">
      <PopUp
        handleSubmit={props.togglePopUp}
        title={"Cambio Password"}
        description={""}
      >
        <ChangePassword {...props} />
      </PopUp>
    </div>
  );
}
